import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import useLogin from '../../api/hooks/authentication/useLogin';
import useUser from '../../api/hooks/useUser';
import Footer from '../../components/Footer';
import CustomInput from '../../components/inputs/CustomInput';
import LogMessage from '../../components/misc/LogMessage';
import MyNavigator from '../../components/misc/MyNavigator';
import { cookieName } from '../../consts/cookie';
import { authInputs } from '../../consts/inputs';
import { logMsgBgColors } from '../../consts/misc';
import { toAssets } from '../../consts/Paths';
import { possible_statuses } from '../../consts/possible_statuses';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import useLogMessage from '../../hooks/useLogMessage';
import useToggle from '../../hooks/useToggle';
import '../../styles/Access.css';
import '../../styles/Content.css';
import '../../styles/General.css';
import { getInputs } from '../../utils/getMethods';
import { deleteCookie, getCookie, setCookie } from '../../utils/handleCookie';
import { fetchRequest, getOptions } from '../../api/utils';
import { apiURL } from '../../consts/URLs';
import { LOGIN } from '../../api/endpointList';
import { Role } from '../../interfaces';

const LoginPage = (props: any) => {
    const { isMobile } = useIsMobile();
    const navigateNow = useToggle(false);
    const { setUser, user, setToken, token } = useContext(MainContext);
    const { loginResponse, loginResult, login } = useLogin();
    const { RESPONSES, RESULTS, CTAs } = useUser();
    const { isToggled, message, write } = useLogMessage();
    const registerForm = useForm();

    const [rememberMe, setRememberMe] = useState(false);

    useEffect(() => {
        if (getCookie(cookieName.token)) {
            registerForm.setValue('remember_me', true);
        }
    }, []);

    useEffect(() => {
        if (token && window.location.pathname === `/login`) {
            CTAs.getUserByToken(token);
        }
    }, [token]);

    useEffect(() => {
        if (loginResponse?.ok) {
            setUser({
                id: loginResult.user.id,
                name: loginResult.user.name,
                surname: '',
                roles: loginResult.user.roles.map((role: Role) => ({
                    id: role.id,
                    notes: role.notes,
                    role: role.role,
                    pivot: {
                        user_id: role.pivot.user_id,
                        role_id: role.pivot.role_id,
                    },
                })),
                email: loginResult.user.email,
                status: '',
                password: loginResult.user.password,
            });
            localStorage.setItem(
                'userData',
                JSON.stringify({
                    id: loginResult.user.id,
                    name: loginResult.user.name,
                    surname: '',
                    roles: loginResult.user.roles.map((role: Role) => ({
                        id: role.id,
                        notes: role.notes,
                        role: role.role,
                        pivot: {
                            user_id: role.pivot.user_id,
                            role_id: role.pivot.role_id,
                        },
                    })),
                    email: loginResult.user.email,
                    status: '',
                    password: loginResult.user.password,
                })
            );
            localStorage.setItem('userToken', loginResult.token);
            if (rememberMe && token) {
                setCookie(
                    cookieName.user_essential,
                    JSON.stringify({
                        id: loginResult.user.id,
                        type: '',
                    })
                );
                setCookie(cookieName.token, token);
            }

        }
    }, [loginResponse, user]);

    useEffect(() => {
        /* console.log(loginResponse, loginResult);   */
        if (loginResponse?.ok) {
            setToken(loginResult.token);
            window.location.href='/offers';
        } else if (loginResponse?.ok === false) {
            write('subject', 'Incorrect credentials ');
            write('other_text', 'try again');
            write('bgColor', logMsgBgColors.error);
        }
    }, [loginResponse, token]);

    const onSubmit = (data: any) => {
        if (data.remember_me) {
            setRememberMe(true);
        } else if (data.remember_me === false) {
            setRememberMe(true);
        }
        login({ email: data.email, password: data.password });
    };

    const chosenInputs = getInputs(authInputs, ['email', 'password']);
    const renderInputs = chosenInputs.map((input, key) => {
        return <CustomInput width={'100%'} key={key} {...input} register={registerForm.register} errors={registerForm.formState.errors} />;
    });

    const onCheckboxTitleClick = () => {
        const checkboxValue = registerForm.getValues('remember_me');
        registerForm.setValue('remember_me', !checkboxValue);
    };

    return (
        <div /* id="bgAll" */ className='access-background'>
            {isToggled && (
                <LogMessage
                    text={{
                        subject: message.subject,
                        complement: message.complement,
                        other_text: message.other_text,
                    }}
                    bgColor={message.bgColor}
                />
            )}

            <MyNavigator path={`/offers`} trigger={navigateNow} />

            <div className={`access-content-box ${isMobile && 'a-c-b-Mob'}`}>
                <div className='access-content-box-inner-wrapper'>
                    <div className='access-contentBox-header'>
                        <div className='cornerTitle'>
                            {'Log in'}
                            <p className='cornerSubTitle'>Enter email and password</p>
                        </div>
                    </div>
                    <div className='input-positioner' style={{ gap: '32px' }}>
                        <form onSubmit={registerForm.handleSubmit(onSubmit)}>
                            {renderInputs}
                            <p
                                className='forgotpassword-link'
                                // onClick={() => {
                                //     window.location.href = `/recoverypassword`;
                                // }}
                            >
                                {/* Forgot password? */}
                            </p>
                            <div className='contentBox-confirmationBox'>
                                <span className='rememberMeBox'>
                                    <input type={'checkbox'} {...registerForm.register('remember_me')} style={{ cursor: 'pointer' }} checked={true} />
                                    <p className='rememberMe-text' onClick={onCheckboxTitleClick}>
                                        Remember Me
                                    </p>
                                </span>
                                <button className='button1 b-medium' type='submit' style={{ width: isMobile ? '125px' : '' }}>
                                    <p className='button1-text'>{'Log In'}</p>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {isToggled && (
                <LogMessage
                    text={{
                        subject: message.subject,
                        other_text: message.other_text,
                        complement: message.complement,
                    }}
                    bgColor={message.bgColor}
                />
            )}
            {/* <Footer /> */}
        </div>
    );
};
export default LoginPage;
